import { FC } from "react";
import SearchScafold from "@/components/SearchScafold";
import { SelectionProps } from "@/interfaces/SelectionProps";
import RangeSlider from "@/components/RangeSlider";

import {
  SizeFormField,
  SizeRangeSliderMax,
  SizeRangeSliderMin,
  SizeRangeSliderStep,
  SizeRangeSliderUnit,
} from "@/consts/RangeSlider";
import useRangeSlider from "@/hooks/useRangeSlider";

const SizeSelection: FC<SelectionProps<SizeFormField>> = ({
  defaultValue,
  onUpdate,
  onBack,
}): JSX.Element => {
  const widthSlider = useRangeSlider({
    defaultMin: defaultValue.min_width,
    defaultMax: defaultValue.max_width,
    min: SizeRangeSliderMin,
    max: SizeRangeSliderMax,
  });

  const heightSlider = useRangeSlider({
    defaultMin: defaultValue.min_height,
    defaultMax: defaultValue.max_height,
    min: SizeRangeSliderMin,
    max: SizeRangeSliderMax,
  });

  const depthSlider = useRangeSlider({
    defaultMin: defaultValue.min_depth,
    defaultMax: defaultValue.max_depth,
    min: SizeRangeSliderMin,
    max: SizeRangeSliderMax,
  });

  return (
    <SearchScafold
      title={"サイズ"}
      handleSubmit={() => {
        onUpdate({
          min_width: widthSlider.minQueryValue,
          max_width: widthSlider.maxQueryValue,
          min_height: heightSlider.minQueryValue,
          max_height: heightSlider.maxQueryValue,
          min_depth: depthSlider.minQueryValue,
          max_depth: depthSlider.maxQueryValue,
        });
        onBack();
      }}
    >
      <ul className="BorderList">
        <li className="p-20 flex flex-col space-y-8 text-xs">
          <p className="font-bold">幅</p>
          <RangeSlider
            rangeSlider={widthSlider}
            step={SizeRangeSliderStep}
            unit={SizeRangeSliderUnit}
          />
        </li>

        <li className="p-20 flex flex-col space-y-8 text-xs">
          <p className="font-bold">高さ</p>
          <RangeSlider
            rangeSlider={heightSlider}
            step={SizeRangeSliderStep}
            unit={SizeRangeSliderUnit}
          />
        </li>

        <li className="p-20 flex flex-col space-y-8 text-xs">
          <p className="font-bold">奥行き</p>
          <RangeSlider
            rangeSlider={depthSlider}
            step={SizeRangeSliderStep}
            unit={SizeRangeSliderUnit}
          />
        </li>
      </ul>
    </SearchScafold>
  );
};
export default SizeSelection;
